import { render, staticRenderFns } from "./mo-alert.html?vue&type=template&id=ea7a40c4&external"
import script from "./mo-alert.ts?vue&type=script&lang=ts&external"
export * from "./mo-alert.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-alert.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports